import {
    REQUEST_RECEIVES,
    FETCH_RECEIVES_SUCCESS,
    FETCH_RECEIVES_FAILURE,
    SELECT_RECEIVE,
    RESET_CURRENT_RECEIVE,
    REQUEST_CREATING_RECEIVE,
    CREATE_RECEIVE_SUCCESS,
    CREATE_RECEIVE_FAILURE,
    RESET_CREATE_RECEIVE,
    REQUEST_EDITING_RECEIVE,
    EDIT_RECEIVE_SUCCESS,
    EDIT_RECEIVE_FAILURE,
    REQUEST_RECEIVE_DETAIL,
    FETCH_RECEIVE_DETAIL_SUCCESS,
    FETCH_RECEIVE_DETAIL_FAILURE,
    COMPLETE_PURCHASE_ORDER,
    COMPLETE_PURCHASE_ORDER_SUCCESS,
    COMPLETE_PURCHASE_ORDER_FAILURE,
    FETCH_RECEIVE_HISTORY,
    FETCH_RECEIVE_HISTORY_SUCCESS,
    FETCH_RECEIVE_HISTORY_FAILURE,
    SELECT_RECEIVE_HISTORY,
    RESET_CURRENT_RECEIVE_HISTORY,
    FETCH_RECEIVE_HISTORY_DETAIL,
    FETCH_RECEIVE_HISTORY_DETAIL_SUCCESS,
    FETCH_RECEIVE_HISTORY_DETAIL_FAILURE,
    FETCH_ALL_RECEIVE_HISTORY_DETAIL,
    FETCH_ALL_RECEIVE_HISTORY_DETAIL_SUCCESS,
    FETCH_ALL_RECEIVE_HISTORY_DETAIL_FAILURE,
    FETCH_RECEIVE_HISTORY_DETAIL_RECORD,
    FETCH_RECEIVE_HISTORY_DETAIL_RECORD_SUCCESS,
    FETCH_RECEIVE_HISTORY_DETAIL_RECORD_FAILURE,
    REQUEST_EDITING_RECEIVE_HISTORY,
    EDIT_RECEIVE_HISTORY_SUCCESS,
    EDIT_RECEIVE_HISTORY_FAILURE,
    RESET_EDIT_RECEIVE_HISTORY,
    DELETE_RECEIVE,
    DELETE_RECEIVE_FINISHED,
    RESET_DELETE_STATUS,
    ATTACH_FILES,
    ATTACH_FILES_SUCCESS,
    ATTACH_FILES_FAILURE,
    FETCH_ATTACHED_FILES,
    FETCH_ATTACHED_FILES_SUCCESS,
    FETCH_ATTACHED_FILES_FAILURE,
    DELETE_ATTACHED_FILES,
    DELETE_ATTACHED_FILES_SUCCESS,
    DELETE_ATTACHED_FILES_FAILURE,
    RESET_ATTACHED_FILES
} from '../actions/type';

const INITIAL_STATE = {
    all: null,
    currentReceive: null,
    currentReceiveDetail: null,
    isLoading: false,
    error: null,
    detailIsLoading: false,
    detailError: null,
    isCreating: false,
    createError: null,
    created: false,
    createdReceive: null,
    isEditing: false,
    editError: null,
    edited: false,
    isCompleting: false,
    completeError: null,
    completed: false,
    isfetchingReceiveHistory: false,
    fetchedReceiveHistory: null,
    fetchReceiveHistoryError: null,
    currentReceiveHistory: null,
    isfetchingAllReceiveHistoryDetail: true,
    fetchAllReceiveHistoryDetailError: null,
    fetchedAllReceiveHistoryDetail: null,
    isfetchingReceiveHistoryDetailRecord: false,
    fetchReceiveHistoryDetailRecordError: null,
    fetchedReceiveHistoryDetailRecord: null,
    isEditingReveiveHistory: false,
    editReceiveHistoryError: null,
    editedReceiveHistory: null,
    isAttachingFiles: false,
    attachFilesError: null,
    attachFilesSuccess: false,
    isfetchingAttachedFiles: false,
    fetchAttachedFilesError: null,
    fetchedAttachedFiles: null,
    isDeletingFiles: false,
    deleteFilesError: null,
    deleteFilesSuccess: false,
    voidStatus: null,
    voidIsLoading: false,
    voidError: null,
    receiveLoading: false,
};

export default function (state = INITIAL_STATE, action) {
    switch (action.type) {
        case REQUEST_RECEIVES:
            return { ...state, error: null, isLoading: true };
        case FETCH_RECEIVES_SUCCESS:
            return { ...state, all: action.payload.data, error: null, isLoading: false };
        case FETCH_RECEIVES_FAILURE:
            const error = action.payload || { message: action.payload.message }; // 2nd term stands for network or server down errors
            console.log("fetch receives fail", action.payload)
            return { ...state, all: [], error: error, isLoading: false };
        case SELECT_RECEIVE:
            return { ...state, currentReceive: action.payload, fetchedAttachedFiles: null };
        case RESET_CURRENT_RECEIVE:
            return { ...state, currentReceive: null, currentReceiveDetail: null, editError: null, createError: null };
        case REQUEST_CREATING_RECEIVE:
            return { ...state, isCreating: true, createError: null, created: false, createdReceive: null, receiveLoading: true };
        case CREATE_RECEIVE_SUCCESS:
            return { ...state, isCreating: false, createError: null, created: true, createdReceive: action.payload.data, receiveLoading: false };
        case CREATE_RECEIVE_FAILURE:
            const createError = action.payload.data || { message: action.payload.message }; // 2nd term stands for network or server down errors
            return { ...state, isCreating: false, createError: createError, created: false, createdReceive: null, receiveLoading: false };
        case RESET_CREATE_RECEIVE:
            return { ...state, isCreating: false, createError: null, created: false, createdReceive: null };
        case REQUEST_EDITING_RECEIVE:
            return { ...state, isEditing: true, editError: null, edited: false };
        case EDIT_RECEIVE_SUCCESS:
            return { ...state, isEditing: false, editError: null, edited: true };
        case EDIT_RECEIVE_FAILURE:
            const editError = action.payload.data || { message: action.payload.message }; // 2nd term stands for network or server down errors
            return { ...state, isEditing: false, editError: editError, edited: false };
        case REQUEST_RECEIVE_DETAIL:
            return { ...state, detailError: null, detailIsLoading: true };
        case FETCH_RECEIVE_DETAIL_SUCCESS:// return list of posts and make loading = false
            return { ...state, currentReceiveDetail: action.payload.data, detailError: null, detailIsLoading: false };
        case FETCH_RECEIVE_DETAIL_FAILURE:// return error and make loading = false
            const detailError = action.payload || { message: action.payload.message };//2nd one is network or server down errors
            console.log("fetch receive detail fail", action.payload);
            alert(JSON.stringify(detailError));
            return { ...state, all: null, detailError: detailError, detailIsLoading: false };
        case COMPLETE_PURCHASE_ORDER:
            return {...state, isCompleting: true, completeError: null, completed: false};
        case COMPLETE_PURCHASE_ORDER_SUCCESS:
            return {...state, isCompleting: false, completeError: null, completed: true};
        case COMPLETE_PURCHASE_ORDER_FAILURE:
            const completeError = action.payload.data || {message: action.payload.message};
            return {...state, isCompleting: false, completeError: completeError, completed: false};


        case FETCH_RECEIVE_HISTORY:
            return {...state, isfetchingReceiveHistory: true, fetchReceiveHistoryError: null, fetchedReceiveHistory: null};
        case FETCH_RECEIVE_HISTORY_SUCCESS:
            return {...state, isfetchingReceiveHistory: false, fetchReceiveHistoryError: null, fetchedReceiveHistory: action.payload.data};
        case FETCH_RECEIVE_HISTORY_FAILURE:
            const fetchReceiveHistoryError = action.payload.data || {message: action.payload.message};
            return {...state, isfetchingReceiveHistory: false, fetchReceiveHistoryError: fetchReceiveHistoryError, fetchedReceiveHistory: null};
        case SELECT_RECEIVE_HISTORY:
            return { ...state, currentReceiveHistory: action.payload };
        case RESET_CURRENT_RECEIVE_HISTORY:
            return { ...state, currentReceiveHistory: null, fetchedReceiveHistoryDetailRecord: null};
        case FETCH_RECEIVE_HISTORY_DETAIL:
            return {...state, isfetchingReceiveHistoryDetail: true, fetchReceiveHistoryDetailError: null, fetchedReceiveHistoryDetail: null};
        case FETCH_RECEIVE_HISTORY_DETAIL_SUCCESS:
            return {...state, isfetchingReceiveHistoryDetail: false, fetchReceiveHistoryDetailError: null, fetchedReceiveHistoryDetail: action.payload.data};
        case FETCH_RECEIVE_HISTORY_DETAIL_FAILURE:
            const fetchReceiveHistoryDetailError = action.payload.data || {message: action.payload.message};
            alert(JSON.stringify(fetchReceiveHistoryDetailError));
            return {...state, isfetchingReceiveHistoryDetail: false, fetchReceiveHistoryDetailError: fetchReceiveHistoryDetailError, fetchedReceiveHistoryDetail: null};

        case FETCH_ALL_RECEIVE_HISTORY_DETAIL:
            return {...state, isfetchingAllReceiveHistoryDetail: true, fetchAllReceiveHistoryDetailError: null, fetchedAllReceiveHistoryDetail: null};
        case FETCH_ALL_RECEIVE_HISTORY_DETAIL_SUCCESS:
            return {...state, isfetchingAllReceiveHistoryDetail: false, fetchAllReceiveHistoryDetailError: null, fetchedAllReceiveHistoryDetail: action.payload.data};
        case FETCH_ALL_RECEIVE_HISTORY_DETAIL_FAILURE:
            const fetchAllReceiveHistoryDetailError = action.payload.data || {message: action.payload.message};
            return {...state, isfetchingAllReceiveHistoryDetail: false, fetchAllReceiveHistoryDetailError: fetchAllReceiveHistoryDetailError, fetchedAllReceiveHistoryDetail: null};
        case FETCH_RECEIVE_HISTORY_DETAIL_RECORD:
            return {...state, isfetchingReceiveHistoryDetailRecord: true, fetchReceiveHistoryDetailRecordError: null, fetchedReceiveHistoryDetailRecord: null};
        case FETCH_RECEIVE_HISTORY_DETAIL_RECORD_SUCCESS:
            return {...state, isfetchingReceiveHistoryDetailRecord: false, fetchReceiveHistoryDetailRecordError: null, fetchedReceiveHistoryDetailRecord: action.payload.data};
        case FETCH_RECEIVE_HISTORY_DETAIL_RECORD_FAILURE:
            const fetchReceiveHistoryDetailRecordError = action.payload.data || {message: action.payload.message};
            alert(JSON.stringify(fetchReceiveHistoryDetailRecordError));
            return {...state, isfetchingReceiveHistoryDetailRecord: false, fetchReceiveHistoryDetailRecordError: fetchReceiveHistoryDetailRecordError, fetchedReceiveHistoryDetailRecord: null};

        case REQUEST_EDITING_RECEIVE_HISTORY:
            return { ...state, isEditingReveiveHistory: true, editReceiveHistoryError: null, editedReceiveHistory: null };
        case EDIT_RECEIVE_HISTORY_SUCCESS:
            return { ...state, isEditingReveiveHistory: false, editReceiveHistoryError: null, editedReceiveHistory: action.payload.data };
        case EDIT_RECEIVE_HISTORY_FAILURE:
            const editReceiveHistoryError = action.payload.data || { message: action.payload.message };
            alert(JSON.stringify(editReceiveHistoryError));
            return { ...state, isEditingReveiveHistory: false, editReceiveHistoryError, editedReceiveHistory: null };
        case RESET_EDIT_RECEIVE_HISTORY:
            return { ...state, isEditingReveiveHistory: false, editReceiveHistoryError: null, editedReceiveHistory: null };

        case DELETE_RECEIVE:
            return {...state, voidStatus: '', voidIsLoading: true, voidError: null};
        case DELETE_RECEIVE_FINISHED:
          return {...state, voidStatus: action.payload.data, voidIsLoading: false };
        case RESET_DELETE_STATUS:
          return {...state, voidStatus: '', voidIsLoading: false, voidError: null};

        case ATTACH_FILES:
            return {...state, isAttachingFiles: true, attachFilesError: null, attachFilesSuccess: false};
        case ATTACH_FILES_SUCCESS:
            return {...state, isAttachingFiles: false, attachFilesError: null, attachFilesSuccess: true};
        case ATTACH_FILES_FAILURE:
            const attachFilesError = action.payload.data || {message: action.payload.message};
            return {...state, isAttachingFiles: false, attachFilesError: attachFilesError, attachFilesSuccess: false};
        case FETCH_ATTACHED_FILES:
            return {...state, isfetchingAttachedFiles: true, fetchAttachedFilesError: null, fetchedAttachedFiles: null};
        case FETCH_ATTACHED_FILES_SUCCESS:
            return {...state, isfetchingAttachedFiles: false, fetchAttachedFilesError: null, fetchedAttachedFiles: action.payload.data};
        case FETCH_ATTACHED_FILES_FAILURE:
            const fetchAttachedFilesError = action.payload.data || {message: action.payload.message};
            return {...state, isfetchingAttachedFiles: false, fetchAttachedFilesError: fetchAttachedFilesError, fetchedAttachedFiles: null};
        case DELETE_ATTACHED_FILES:
            return {...state, isDeletingFiles: true, deleteFilesError: null, deleteFilesSuccess: false};
        case DELETE_ATTACHED_FILES_SUCCESS:
            return {...state, isDeletingFiles: false, deleteFilesError: null, deleteFilesSuccess: true, fetchedAttachedFiles: null};
        case DELETE_ATTACHED_FILES_FAILURE:
            const deleteFilesError = action.payload.data || {message: action.payload.message};
            return {...state, isDeletingFiles: false, deleteFilesError: deleteFilesError, deleteFilesSuccess: false};
        case RESET_ATTACHED_FILES:
            return {...state, fetchedAttachedFiles: null};


        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./master/jsx/reducers/receive_reducer.js